import React, { Component } from 'react';
// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import { observer } from 'mobx-react';
import './Imprint.scss';

@observer class Imprint extends Component<any, any> {

	render() {
			return (
				<div className="imprint-wrapper">
                    <p>Multimediaprojekt 1 von Tobias Franek</p>
                    <p>FH Salzburg - MultiMediaTechnology</p>
                    <p>Kontakt: tfranek.mmt-b2018@fh.salzburg.ac.at</p>
				</div>  
			)
	}
}

export default Imprint;